import RuvixxDate from "components/RuvixxDate";
import SwoogoSyncStatusPopover from "routes/swoogo/SwoogoSyncStatusPopover";

// Muted last-synced sub-line for the Swoogo section group: the last-synced time,
// a "Never synced" placeholder, or "Syncing…" while a sync is in flight. The
// outcome is reported by the status popover rendered alongside it.
const SwoogoLastSynced = ({
  syncStatus,
  lastSyncedAt,
  syncError,
  syncSkipped,
  syncSkippedCount,
}) => (
  <span className="tw:flex tw:items-start tw:gap-1 tw:text-xs tw:text-[var(--color-text-secondary)]">
    <SwoogoSyncStatusPopover
      syncStatus={syncStatus}
      lastSyncedAt={lastSyncedAt}
      syncError={syncError}
      skipped={syncSkipped}
      skippedCount={syncSkippedCount}
    />
    {/* RuvixxDate renders its relative time in a block div; forcing descendants
        inline lets the label and time flow as one wrapping line in the rail. */}
    <span className="tw:min-w-0 tw:[&_div]:inline">
      {syncStatus === "pending" ? (
        "Syncing…"
      ) : lastSyncedAt ? (
        <>
          Synced <RuvixxDate date={lastSyncedAt} />
        </>
      ) : (
        "Never synced"
      )}
    </span>
  </span>
);

export default SwoogoLastSynced;
